module.exports = __webpack_public_path__ + "static/img/QR_wechat_video.c3c9be79.png";